import { Component } from '@theme/component';

/**
 * @typedef {object} WaveMarqueeRefs
 * @property {SVGSVGElement} svg - The wave SVG holding the SMIL text animation.
 */

/**
 * Wave marquee — pauses the SVG's scrolling text for visitors who prefer reduced motion.
 * The scrolling itself is SMIL (<animate> on the textPath offset) in
 * sections/ex___wave-marquee.liquid, which CSS media queries cannot stop.
 *
 * @extends {Component<WaveMarqueeRefs>}
 */
class ExWaveMarquee extends Component {
  requiredRefs = ['svg'];

  #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  connectedCallback() {
    super.connectedCallback();
    this.#syncMotion();
    this.#reducedMotion.addEventListener('change', this.#syncMotion);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#reducedMotion.removeEventListener('change', this.#syncMotion);
  }

  #syncMotion = () => {
    if (this.#reducedMotion.matches) {
      this.refs.svg.pauseAnimations();
    } else {
      this.refs.svg.unpauseAnimations();
    }
  };
}

if (!customElements.get('ex-wave-marquee')) {
  customElements.define('ex-wave-marquee', ExWaveMarquee);
}
